/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";

import Search from "./Search";
import {fetchFaqs} from "api";
import {triggerToast} from "helpers";

const SearchContainer = ({
  setFaqData,
  totalResults
}) => {
  const handleFaqSearch = async (searchQuery) => {
    try {
      const searchedFaqs = await fetchFaqs(searchQuery);
      setFaqData(searchedFaqs?.data?.results ?? []);
    } catch (err) {
      triggerToast("Could not load FAQs. Please try again.", "error");
    }
  };

  return (
    <Search
      handleFaqSearch={handleFaqSearch}
      totalResults={totalResults}
    />
  );
};

export default SearchContainer;
